import { AxiosResponse } from "axios";
import IHttpPostServiceProps from "./IHttpPostServiceProps";
import TrimJson from "Utils/TrimJson";
import { instance } from 'Services/instance'
import { ToastCreateSuccessBottomLeft } from "Utils/toastService";
import i18n from "i18next";

const { t } = i18n

const HttpPostService = async (props: IHttpPostServiceProps) => {
  if (props.onResult === undefined) {
    props.onResult = (res: AxiosResponse<any, any>): any => {
      if (res.status === 201) {
        ToastCreateSuccessBottomLeft(t("VISIT"))
        return res.data ? res.data : true;
      }
    };
  }
  if (props.onError === undefined) {
    props.onError = (error: any) => {
      console.error(error);
    };
  }

  try {
    const body = TrimJson(props.body)
    const response = await instance.post(props.url, body)
      .then(props.onResult)
      .catch(props.onError);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export default HttpPostService;
